import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import MasterNumber from '../../YourInformation/components/MasterNumber'
import PlateNumber from '../../YourInformation/components/PlateNumber'
import VinSerialNumber from '../../YourInformation/components/VinSerialNumber'
import { clearPermitAction, screenLoadingAction, vehicleTypeAction } from 'redux/actions'
import { processMasterNumberAction } from 'redux/reducers/apiReducers/processMasterNumberReducer'
import { getServiceAvailableAction } from 'redux/reducers/apiReducers/serviceAvailableReducer'

const AddPermitView = ({ t, i18n, setIsError }) => {
  const history = useHistory()
  const dispatch = useDispatch()

  const [masterNumberValid, setMasterNumberValid] = useState('')
  const [plateNumberValid, setPlateNumberValid] = useState('')
  const [vinSerialNumberValid, setVinSerialNumberValid] = useState('')
  const [errMsg, setErrMsg] = useState('')

  const [masterNumberError, setMasterNumberError] = useState('your_information.master_number_error')
  const [plateNumberError, setPlateNumberError] = useState('your_information.plate_number_error')
  const [vinSerialNumberError, setVinSerialNumberError] = useState('your_information.vin_serial_number_error')

  const { masterNumber, plateNumber, vinSerialNumber, permits } = useSelector((state) => state.app)

  useEffect(() => {
    try {
      dispatch(clearPermitAction())
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [])

  const onAddPermit = () => {
    try {
      if (validateFields()) {
        setErrMsg('')
        dispatch(screenLoadingAction())
        dispatch(getServiceAvailableAction())
          .then((serviceAvailableres) => {
            if (serviceAvailableres['data']) {
              dispatch(processMasterNumberAction(masterNumber.toUpperCase(), plateNumber, vinSerialNumber))
                .then((res) => {
                  if (res['messageCode'] === 'OVPR000') {
                    if (res['vehicleData']['fisherman']) {
                      dispatch(vehicleTypeAction('fisherman'))
                      history.push(`/${i18n.language}${t('routes.eligibility_question_fishing')}`)
                    } else if (res['vehicleData']['farmer']) {
                      dispatch(vehicleTypeAction('farmer'))
                      history.push(`/${i18n.language}${t('routes.eligibility_question_farm')}`)
                    } else {
                      if (res['feeTerms'] && res['feeTerms'].length > 0) {
                        dispatch(vehicleTypeAction('regular'))
                        history.push(`/${i18n.language}${t('routes.renewal_period')}`)
                      } else {
                        history.push(`/${i18n.language}${t('routes.cannot_process_permit')}`)
                      }
                    }
                  } else {
                    history.push(`/${i18n.language}${t('routes.cannot_process_permit')}`)
                  }
                  dispatch(screenLoadingAction())
                })
                .catch((e) => {
                  setErrMsg('your_information.service_not_available_error')
                  console.log(e)
                  dispatch(screenLoadingAction())
                })
            } else {
              setErrMsg('your_information.service_not_available_error')
              dispatch(screenLoadingAction())
            }
          })
          .catch((err) => {
            console.log(err)
            setErrMsg('your_information.service_not_available_error')
            dispatch(screenLoadingAction())
          })
      }
    } catch (e) {
      console.log(e)
      setErrMsg('your_information.service_not_available_error')
    }
  }

  const validateFields = () => {
    try {
      validateMasterNumber(masterNumber)
      validatePlateNumber(plateNumber)
      validateVinSerialNumber(vinSerialNumber)
      if (masterNumber === '') {
        setMasterNumberValid(false)
      }
      if (plateNumber === '') {
        setPlateNumberValid(false)
      }
      if (vinSerialNumber === '') {
        setVinSerialNumberValid(false)
      }
      return (
        masterNumberValid === true &&
        plateNumberValid === true &&
        vinSerialNumberValid === true &&
        masterNumber !== '' &&
        plateNumber !== '' &&
        vinSerialNumber !== ''
      )
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validatePermitExist = (permit) => {
    try {
      return permits.find((permitInfo) => permitInfo.plateNumber === permit)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateVINExist = (vin) => {
    try {
      return permits.find((permitInfo) => permitInfo.vinSerialNumber === vin)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateMasterNumber = (masterNumberElem) => {
    const regex = RegExp(/^[a-zA-Z0-9 ]{14}$/i)
    const lettersRegex = RegExp(/^[a-zA-Z ]{5}$/i)
    if (masterNumberElem.length > 0) {
      let nameMasterNumber = masterNumberElem.substring(0, 5)
      if (regex.test(masterNumberElem) && lettersRegex.test(nameMasterNumber) && !isNaN(masterNumberElem.substring(5))) {
        setMasterNumberValid(true)
        return true
      } else {
        setMasterNumberValid(false)
        setMasterNumberError('your_information.master_number_error_invalid')
        return false
      }
    } else {
      setMasterNumberValid(false)
      setMasterNumberError('your_information.master_number_error')
      return false
    }
  }

  const validatePlateNumber = (plate) => {
    try {
      const regex = RegExp(/^[a-z0-9]{4,7}$/i)
      if (regex.test(plate)) {
        if (validatePermitExist(plate)) {
          setPlateNumberValid(false)
          setPlateNumberError('your_information.permit_exists')
        } else {
          setPlateNumberValid(true)
        }
      } else {
        setPlateNumberValid(false)
        setPlateNumberError('your_information.plate_number_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateVinSerialNumber = (number) => {
    try {
      const regex = RegExp(/^[a-z0-9]{4}$/i)
      if (regex.test(number)) {
        if (validateVINExist(number)) {
          setVinSerialNumberValid(false)
          setVinSerialNumberError('your_information.vin_exists')
        } else {
          setVinSerialNumberValid(true)
        }
      } else {
        setVinSerialNumberValid(false)
        setVinSerialNumberError('your_information.vin_serial_number_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-xs-12 col-lg-12">
          <h2>{t('permits_list.or_add_another')}</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-12">
          <MasterNumber
            validateMasterNumber={validateMasterNumber}
            masterNumberError={masterNumberError}
            masterNumberValid={masterNumberValid}
            isDisabled={true}
            setIsError={setIsError}
          />
          <PlateNumber
            validatePlateNumber={validatePlateNumber}
            plateNumberError={plateNumberError}
            plateNumberValid={plateNumberValid}
            setIsError={setIsError}
          />
          <VinSerialNumber
            validateVinSerialNumber={validateVinSerialNumber}
            vinSerialNumberError={vinSerialNumberError}
            vinSerialNumberValid={vinSerialNumberValid}
            setIsError={setIsError}
          />
        </div>
      </div>
      <div className="form-group has-error">
        <button
          className="btn-lg btn-default"
          style={{ marginBottom: errMsg !== '' && '5px' }}
          onClick={onAddPermit}
          value={t('permits_list.add_renewal')}
          name={t('permits_list.add_renewal')}
        >
          {t('permits_list.add_renewal')}
        </button>{' '}
        {errMsg !== '' && <i className="fa fa-exclamation-circle" aria-hidden="true" />}
        <div className="help-block">{t(errMsg)}</div>
      </div>
    </React.Fragment>
  )
}

export default withTranslation('common')(AddPermitView)
